<template>
<v-container fluid>
	<div v-if="!loading">
		<div v-if="segments.length">
			<!--segments tab--><!--table head-->			
			<v-row class="mt-2 total" no-gutters>
				<v-col class="tabCell" v-for="item in headers"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<v-row v-for="segment in segments" :key="segment.id" no-gutters>
				<v-col class="tabCell text-truncate">{{ segment.name }}</v-col>
				<v-col class="tabCell">{{ segment.family }}</v-col>
				<v-col class="tabCell">{{ segment.attractiveness }}</v-col>
				<v-col class="tabCell">{{ segment.strongPerson }}</v-col>
				<v-col class="tabCell">{{ segment.socStatus}}</v-col>
				<v-col class="tabCell">{{ segment.fun }}</v-col>
				<v-col class="tabCell">{{ segment.friendship }}</v-col>
				<v-col class="tabCell">{{ segment.pets }}</v-col>
				<v-col class="tabCell">{{ segment.brandHigh}}</v-col>
				<v-col class="tabCell">{{ segment.brandSomehow }}</v-col>
				<v-col class="tabCell">{{ segment.brandNot }}</v-col>
				<v-col class="tabCell">
					<change-media :segment="segment" 
						:gameId="gameId"
						:round="round">
					</change-media>
					<delete-segment :segment="segment" 
						:gameId="gameId"
						:round="round">
					</delete-segment>
				</v-col>
			</v-row>
		</div>
	</div>
	<div v-else class="text-center">
		<loader></loader>
	</div> 		
</v-container>
</template>
<script>
	import changeMedia from './modal/changeMedia.vue'
	import deleteSegment from './modal/deleteSegment.vue'
	import Loader from '../../../layouts/Loader.vue'
		
	export default {
		props: ['gameId', 'round'],
		data (){
			return {
				headers: ['Segment', 'Family / kids', 'Personal attractiveness', 'Strong personality', 'Social status', 'Fun','Friendship', 'Pets', 'Brand importance high', 'Brand importance somehow', 'Not at brand importance', 'Action']
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			segments () {
				return this.$store.getters.segments
			}
		},
		methods: {},
		components: {
			changeMedia,
			deleteSegment,
			Loader
		}
	}
</script>